import { css, html, htmlArray } from "../helpers/webComponents";
import { InventoryService } from "../services/InventoryService";

/** CSS affecting the {@link InventoryComponent} */
const styles: string = css`
    .inventory-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin-top: 10px;
        border: 2px solid white;
        width: 150px;
    }

    .inventory-top {
        margin-top: 60px;
        margin-left: 30px;
    }

    .content  area {
        cursor: pointer;
    }

    .inventory-image {
        height: 100px;
    }
`;

/**
 * Represents the Start page
 */
export class InventoryComponent extends HTMLElement {
    /**
     * Lo and may thou Behold! The Iventory Array!
     */
    private static _inventory: string[] = [];
    /** Instance of the game route service */
    // private _inventoryService: InventoryService = new InventoryService();

    /**
     * The "constructor" of a Web Component
     */

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        void this.update();

        document.body.addEventListener("click", (e: Event) => {
            if ((e.target as HTMLElement).nodeName === "GAME-ROOT") {
                void this.update();
            }
        });
        this.render();
    }

    public static async getInventory(): Promise<void> {
        const inventory: string[] = await new InventoryService().getInventory();

        InventoryComponent._inventory = inventory;
    }

    public async update(): Promise<void> {
        await InventoryComponent.getInventory();
        console.log(InventoryComponent._inventory);

        this.render();
    }

    /**
     * Render the contents of this page
     */
    private render(): void {
        if (!this.shadowRoot) return;

        const elements: HTMLElement[] = htmlArray`
            <style>
                ${styles}
            </style>
            <div class="inventory-top">Inventory</div>
            ${this.renderContent()}
        `;

        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }

        this.shadowRoot.append(...elements);
    }

    /**
     * Render the header element
     *
     * @returns String with raw HTML for the header element. Can be empty.
     */
    private renderContent(): string | HTMLElement {
        if (InventoryComponent._inventory.length > 0) {
            return html`
            <div class="inventory-content" id="inventory-content">
                ${InventoryComponent._inventory.map(item => html`<span class="inventory-item">${item}</span>`)}
            </div>
        `;
        }
        return html`<div></div>`;
    }
}
